const $ = window.jQuery

const contact = (formNode) => {
  const handleSubmit = (e) => {
    e.preventDefault()

    const formMessages = document.querySelector('.js--form-messages')
    const formElements = Array.from(formNode.elements)

    const data = formElements.reduce((acc, cur) => {
      if (cur.nodeName === 'BUTTON') return acc
      acc[cur.name] = cur.value
      return acc
    }, {action: 'contact_form'})

    formMessages.innerHTML = ''
    formNode.classList.add('form--loading')

    $.ajax({
      method: 'POST',
      url: mehanizacijaJancar.ajaxurl,
      data
    })
    .done(res => {
      const successMsg = $('<ul />', {class: 'msgs msgs--success f--s'}).append($('<li />').text(res.message))
      formMessages.appendChild(successMsg.get(0))
      formNode.classList.add('hidden')
    })
    .fail(err => {
      const errors = err?.responseJSON?.errors || [mehanizacijaJancar.i18n.genericErrorMessage]
      const errorsNode = $('<ul />', {class: 'msgs msgs--error f--s'}).append(errors.map((error) => {
        return $('<li />').text(error)
      }))
      formMessages.appendChild(errorsNode.get(0))
    })
    .always(() => {
      formNode.classList.remove('form--loading')
    })
  }

  formNode.addEventListener('submit', handleSubmit)
}

export default contact
